var Promise = require('faye/src/util/promise');

module.exports = Promise;